import React from "react";
import "./Toggle.css";
import { IconCheckmark } from "../icons";

interface Props {
  name: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => any;
  checked?: boolean;
  label?: string;
}

export const Toggle = ({ name, onChange, checked, label }: Props) => {
  return (
    <span className="ToggleWrapper">
      <label className="switch" htmlFor={name + '-toggle'}>
        <span>{label}</span>
        <span className="slider round">
          <span className="handle">
            <IconCheckmark />
          </span>
        </span>
      </label>
      <input id={name + '-toggle'} type="checkbox" checked={checked} onChange={onChange}/>
    </span>
  );
};
